import React, { useEffect } from 'react'
import { BrowserRouter, Route, Routes, useLocation, Navigate } from 'react-router-dom'
import { Header } from './components/header/Header'
import { Footer } from './components/footer/Footer'
import { Vision } from './pages/company/Vision'
import { Map } from './pages/company/map'
import { Error } from './pages/error/Error'
import { Main } from './pages/main/Main'
import { History } from './pages/company/History'
import { Equipment } from './pages/business/Equipment'
import { Greetings } from './pages/company/Greetings'
import { License } from './pages/company/License'
import { Distribution } from './pages/business/Distribution'
import { Facility } from './pages/business/Facility'
import { Gallery } from './pages/gallery/Gallery'

function App() {
  return (
    <BrowserRouter>
      <MainRouter />
    </BrowserRouter>
  )
}

function MainRouter() {
  const location = useLocation()

  const isErrorPage = location.pathname === '/error'

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [location])

  return (
    <div>
      {!isErrorPage && <Header />}
      <Routes>
        <Route path="/" element={<Main />} />
        <Route path="/company/greetings" element={<Greetings />} />
        <Route path="/company/history" element={<History />} />
        <Route path="/company/license" element={<License />} />
        <Route path="/company/vision" element={<Vision />} />
        <Route path="/company/map" element={<Map />} />
        <Route path="/business/equipment" element={<Equipment />} />
        <Route path="/business/distribution" element={<Distribution />} />
        <Route path="/error" element={<Error />} />
        <Route path="/business/facility" element={<Facility />} />
        <Route path="/gallery/gallery" element={<Gallery />} />
        <Route path="*" element={<Navigate to="/error" replace />} />
      </Routes>
      {!isErrorPage && <Footer />}
    </div>
  )
}

export default App
